var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 8"}},[_c('title',[_vm._v("menu-triangle")]),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('polygon',{attrs:{"points":"5 0 10 8 0 8 5 0"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }